import { render, staticRenderFns } from "./PerfilSga.vue?vue&type=template&id=9156a6e6"
import script from "./PerfilSga.vue?vue&type=script&lang=js"
export * from "./PerfilSga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports